// Water is stored in millilitres (a glass is 250 ml) but nobody thinks in
// millilitres — a target is "three litres", not "3000 ml". Storage stays exact;
// only the display changes.

/**
 * Millilitres → a litre string with no pointless zeros: 3000 → "3",
 * 1750 → "1.75", 250 → "0.25". Max two decimals, because a quarter-glass is
 * the smallest thing anyone logs.
 */
export function litres(ml: number): string {
  const l = ml / 1000;
  return String(Number(l.toFixed(2)));
}

/** "1.75 / 3 L" — the pair shown on the water card. */
export function litreRange(consumedMl: number, targetMl: number): string {
  return `${litres(consumedMl)} / ${litres(targetMl)} L`;
}
